'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaConnectdevelop = function FaConnectdevelop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.8 20q0 0.4-0.3 0.7t-0.6 0.4l-4 6.9q0 0.2 0 0.3 0 0.4-0.2 0.7t-0.6 0.4l-3.8 6.5q0.1 0.2 0.1 0.3 0 0.5-0.3 0.8t-0.8 0.4q-0.5 0-0.8-0.4h-7.8q-0.3 0.4-0.8 0.4t-0.9-0.4h-7.7q-0.3 0.4-0.8 0.4-0.5 0-0.8-0.3t-0.3-0.8q0-0.2 0-0.4l-3.7-6.5q-0.4-0.1-0.6-0.4t-0.3-0.7q0-0.1 0.1-0.3l-4-6.9q-0.4-0.1-0.7-0.4t-0.2-0.7q0-0.4 0.3-0.7t0.6-0.4l3.9-6.7q0 0 0 0t0-0.1q0-0.7 0.6-1l4.1-7q-0.1-0.2-0.1-0.4 0-0.5 0.3-0.8t0.8-0.3q0.5 0 0.9 0.4h7.6q0.4-0.4 0.9-0.4t0.8 0.4h7.7q0.4-0.4 0.9-0.4 0.4 0 0.8 0.3t0.3 0.8q0 0.1-0.1 0.4l4 6.9q0.5 0 0.8 0.4t0.3 0.7q0 0.3-0.1 0.5l3.6 6.3q0.4 0.1 0.6 0.4t0.3 0.7z m-19.2 15.5h7.6l-6.7-6.9h-2.7l-6.7 6.9h7q0.4-0.3 0.8-0.3t0.7 0.3z m-18.4-15.8q0 0.1 0 0.3 0 0.2 0 0.3l4 7q0 0 0.1 0t0.1 0l0.1 0.1 3.6-3.9v-6.7l-3.6-3.8q-0.2 0.2-0.6 0.2z m16.9-15.2h-7.5l3.7 3.9 10.7-3.9h-5.4q-0.3 0.3-0.7 0.3t-0.8-0.3z m13.7 23.5q0-0.1 0.1-0.2l-1.3-1.3-0.3 1.5h1.5z m-2.1 0l0.5-2-4.9-5.2-5.8 6 1.2 1.2h9z m-1.7 7.2l0.3-0.6 1.3-6h-8.3l6.5 6.7q0.1-0.1 0.2-0.1z m-17.8 0.3h0.1l6.7-6.9h-7.3v6.5l0.1 0.1q0.3 0.1 0.4 0.3z m-0.5-7.5h7.8l1.3-1.2-6-6.3-3.1 3.2v4.3z m-3.7 0h3.1v-3.6l-3.2 3.4q0 0.2 0.1 0.2z m0-16q0 0 0 0.1t0 0q0 0.3-0.2 0.6l3.3 3.4v-5.2z m3.7-1.3v6l3 3 5.7-6-4.3-4.6z m0.1-5.9l-0.1 0.1v5.1l4-1.4-3.7-3.9q-0.1 0-0.2 0.1z m17.3-0.3h-0.3l-12.1 4.4 4.2 4.3z m-8.2 9.6l-5.8 6.1 6 6.2 5.8-6z m-6.5 6l-2.7-2.7v5.5z m6.7 7.1l-0.8 0.8h1.7z m6.6-6.8l4.6 4.9 2.6-12.1-0.1-0.1 0 0z m6.6-7.7q-0.1-0.3-0.1-0.6v0l-4.2-7.3q-0.1-0.1-0.3-0.1l-8.4 9 6 6.3z m-23.2-2.4v-4.4l-3.1 5.5z m0 18.3h-3.1l3.1 5.5v-5.5z m21.1 0l-0.9 4.4 2.5-4.4h-1.6z m2.4-1.3l4-7q-0.1-0.2-0.1-0.3 0 0 0.1-0.3l-3.3-5.8-2.5 11.9 1.5 1.6q0.1-0.1 0.3-0.1z' })
        )
    );
};

exports.default = FaConnectdevelop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/connectdevelop.js
// module id = 1306
// module chunks = 0